var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Finalized Syllabus")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " Please make the needed edits based on the feedback received on your Syllabus draft. When finished, please upload the document in PDF and Word format to the Portal, and click submit. "
        )
      ]),
      _c("FileUploader", {
        staticClass: "mt-20 inp-wrap big",
        attrs: {
          text: "Upload(PDF)",
          acceptType: ["PDF"],
          value: _vm.value.file1,
          loadText: "loading",
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "file1")
          }
        }
      }),
      _c("FileUploader", {
        staticClass: "mt-20 inp-wrap big",
        attrs: {
          text: "Upload(Word)",
          acceptType: ["DOC", "DOCX"],
          value: _vm.value.file3,
          loadText: "loading",
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "file3")
          }
        }
      }),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v("Upload merged reading material PDF")
      ]),
      _c("FileUploader", {
        staticClass: "mt-20 inp-wrap big",
        attrs: {
          text: "Upload",
          acceptType: ["PDF"],
          value: _vm.value.file2,
          loadText: "loading",
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "file2")
          }
        }
      }),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }